import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { h as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-B_pWoZ1u-Bxh9jPb6.js';
import { I as Icon } from '../../Icon/Icon-D_Strav1.js';

const PositionedIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40021497__sc-kfvljt-0"
})(["margin-inline-start:", ";", ""], ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const DefaultFooter = ({
  label
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, label, /*#__PURE__*/React__default.createElement(PositionedIcon, {
  type: angleDown
}));

export { DefaultFooter as D };
//# sourceMappingURL=DefaultFooter-BA52tZ-n.js.map
